import type { Config } from '../types';

/**
 * Configuration file factory
 */
export function configFactory<T extends Config>(config: T): Readonly<T> {
  return config;
}
